
import { includesValidator } from '../../common/utils/validator';

const InputSize = {
  Large: 'large',
  Small: 'small',
  ExtraSmall: 'x-small',
};

export default {
  name: 'BbInput',
  props: {
    label: {
      type: String,
      default: '',
    },
    hideDetails: {
      type: [Boolean, String],
      default: 'auto',
    },
    hint: {
      type: String,
      default: '',
    },
    isClearable: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Text',
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isNumberArrowBlockHidden: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: InputSize.Large,
      validator: includesValidator(InputSize),
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text',
    },
    step: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    min: Number,
    max: Number,
  },
  computed: {
    showClearIcon() {
      return this.isClearable && this.text.length > 0;
    },
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input:is-valid-range', this.rangeValidation(value));
        this.$emit('input:is-valid-value', this.valueValidation(value));
        this.$emit('input', value);
      },
    },
  },
  created() {
    this.$emit('input:is-valid-range', this.rangeValidation(this.text));
    this.$emit('input:is-valid-value', this.valueValidation(this.text));
  },
  methods: {
    rangeValidation(value) {
      let crossedRangeName = null;
      if (this.min !== undefined && !this.minValue(value)) {
        crossedRangeName = 'min';
      }
      if (this.max !== undefined && !this.maxValue(value)) {
        crossedRangeName = 'max';
      }
      return crossedRangeName;
    },
    valueValidation(value) {
      const reg = /^-?(?!0{2,})(?:\d+(?:\.\d+)?|\d+\.)$/;
      return reg.test(value);
    },
    minValue(value) {
      return value >= this.min;
    },
    maxValue(value) {
      return value <= this.max;
    },
    clearInput() {
      this.text = '';
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
